import React from 'react';

import './styles.scss';

const SocialIcons = ({ icons }) => {
  return (
    <div className="icons-wrapper">
      {icons.map(({ link, icon, name }, id) => (
        <a key={id} href={link} target="_blank" rel="noopener noreferrer">
          <img className="icon-real" src={icon} alt={name} />
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;
